import { useMemo } from 'react';
import { useAccounts, useFreshness, useHealth } from './queries.js';
import { lastClosedDay, todayLa } from './period.js';
import { readAccountsMemory, usePaybackUrl } from './url-state.js';
/**
 * Общее состояние страницы раздела: свежесть (последний закрытый день),
 * справочник кабинетов, адрес. Пока не ясно, какой период и какие кабинеты
 * (ждём свежесть / справочник для памяти кабинетов), `ready = false` — чтобы
 * не запросить тяжёлый отчёт дважды; пока не ясно, подключён ли раздел, —
 * тоже.
 */
export function usePaybackPage(defaultOf, 
/** `split` из адреса уходит в запрос отчёта только там, где экран умеет делить строки («Кампании»). */
opts = {}) {
    const health = useHealth();
    const freshness = useFreshness();
    const accountsQ = useAccounts();
    const today = todayLa();
    const closedDay = lastClosedDay(freshness.data ?? null, today);
    const accountRows = useMemo(() => accountsQ.data?.items ?? [], [accountsQ.data]);
    const known = useMemo(() => (accountsQ.data ? accountsQ.data.items.map((a) => a.platformAccountId) : null), [accountsQ.data]);
    const url = usePaybackUrl(defaultOf(closedDay, today), known);
    const accountNames = useMemo(() => new Map(accountRows.map((a) => [a.platformAccountId, a.name])), [accountRows]);
    const waitFreshness = !url.customPeriod && freshness.isLoading;
    const waitAccounts = url.search['accounts'] === undefined && readAccountsMemory().length > 0 && accountsQ.isLoading;
    return {
        url,
        period: { from: url.from, to: url.to },
        today,
        closedDay,
        accountRows,
        accountNames,
        // Тяжёлый отчёт — только когда раздел подключён (иначе пять одинаковых 503).
        ready: health.data?.configured === true && !waitFreshness && !waitAccounts && !url.accounts.none,
        reportQuery: {
            from: url.from,
            to: url.to,
            accounts: url.accounts.ids,
            moment: url.moment,
            model: url.model,
            ...(opts.split && url.split ? { split: 'revision' } : {}),
        },
        freshness,
    };
}
//# sourceMappingURL=use-payback-page.js.map